import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';
import { ForgotPasswordPage } from './forgot-password';

@NgModule({
  declarations: [
    ForgotPasswordPage,
  ],
  imports: [
    IonicPageModule.forChild(ForgotPasswordPage),
    ComponentsModule,
    PipesModule,
  ],
})
export class ForgotPasswordPageModule {}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.module.ts